//token的存储，获取和移除
export function setToken(tokenKey, token) {
    return localStorage.setItem(tokenKey, token)
}

export function getToken(tokenKey) {
    return localStorage.getItem(tokenKey)
}

export function removeToken(tokenKey) {
    return localStorage.removeItem(tokenKey)
}

// 获取登录用户信息（is_admin, custom等）
export function getUserInfo() {
    return {
        is_admin: getToken('is_admin'),
        custom: getToken('custom'),
        username: getToken('username'),
        token: getToken('token')
    }
}

// 判断是否为管理员（is_admin == 1 或 custom == "金锋"）
export function isAdmin() {
    const isAdminVal = getToken('is_admin')
    const customVal = getToken('custom')
    return isAdminVal === '1' || isAdminVal === 'true' || customVal === '金锋'
}